import axios from "axios";

export const saveFcmToken = async (token,userId,storeId,registrationId,cashRegisterId) => {
  const data={
    token,userId,storeId,registrationId,cashRegisterId
  }

  const response = await axios.post("https://posible-notification-510278658558.asia-south1.run.app/v1/savefcmtoken", data);
  console.log("response after fcm saving",response);
  return response.data;
};

export const deleteFcmToken = async (token) => {
  try {
    const response = await axios.delete(
      "https://posible-notification-510278658558.asia-south1.run.app/v1/fcmtoken",
      {
        data: { token },   // ✅ important
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Delete FCM Token Error:", error);
    throw error;
  }
};
